import { SupportedFileType } from "../../file";
export const MAX = 'max';
export const MIN = 'min';
export const NUMBER = 'number';
export const RANGE_INPUT_MIN_LENGTH = 0;
export const RANGE_INPUT_MAX_LENGTH = 80;
export const MIN_ERR_MSG = 'Minimum allowed value is';
export const MAX_ERR_MSG = 'Maximum allowed value is';
export const CURRENCY_ERR_MSG = 'Invalid currency. Please enter in number format and maximum allowed value is 9999999.99';
// for Keyboard DatePicker
export const DATE_PICKER_VIEWS = ['month', 'date'];
export const DATE_PICKER_POSITION = 'start';
export const DATE_PICKER_VARIANT = 'inline';
export const DATE_ERR_MSG = 'Invalid date.';
export const REQUIRED = 'required';
export const REQUIRED_FIELD = 'Required field';
export const QUESTIONNAIRE_EVALUATION_ALLOWED_FILE_TYPES = [
    SupportedFileType.MP3,
    SupportedFileType.WMA,
    SupportedFileType.WAV,
    SupportedFileType.AIFF,
    SupportedFileType.AIF,
    SupportedFileType.AIFC,
    SupportedFileType.RAM,
    SupportedFileType.MP4,
    SupportedFileType.AAC,
    SupportedFileType.M4P,
    SupportedFileType.MSV,
    SupportedFileType.DVF,
    SupportedFileType.RA,
    SupportedFileType.DSS,
    SupportedFileType.AVI,
    SupportedFileType.MWV,
    SupportedFileType.MPG,
    SupportedFileType.MOV,
    SupportedFileType.MPEG,
    SupportedFileType.JPEG,
    SupportedFileType.JPE,
    SupportedFileType.JPG,
    SupportedFileType.GIF,
    SupportedFileType.PNG,
    SupportedFileType.WMV,
    SupportedFileType.TIFF,
    SupportedFileType.TIF,
    SupportedFileType.DOC,
    SupportedFileType.DOT,
    SupportedFileType.DOCX,
    SupportedFileType.PDF,
    SupportedFileType.TXT,
    SupportedFileType.RTF,
    SupportedFileType.XLS,
    SupportedFileType.XLSX,
    SupportedFileType.XLM,
    SupportedFileType.XLA,
    SupportedFileType.XLC,
    SupportedFileType.XLT,
    SupportedFileType.XLW,
    SupportedFileType.M4A,
    SupportedFileType.MPGA,
    SupportedFileType.MP2,
    SupportedFileType.MP2A,
    SupportedFileType.M2A,
    SupportedFileType.M3A,
    SupportedFileType.EML,
    SupportedFileType.MIME,
    SupportedFileType.MSG,
    SupportedFileType.CSV,
    SupportedFileType.ZIP
];
export const DOWNLOAD_TEXT = 'Download';
export const DELETE_TEXT = 'Delete';
export const CANCEL_TEXT = 'Cancel';
export const ATTACHMENT_TEXT = 'Attachment';
export const DELETE_ATTACHEMENT_TEXT = `Delete ${ATTACHMENT_TEXT}`;
export const PERMANENTLY_DELETE_ATTACHMENT_TEXT = `Permanently ${DELETE_TEXT}`;
export const CLOSE_TEXT = 'Close';
export const OF = 'of';
export const SLIDE_SHOW_IMAGE_WIDTH = '300';
export const THUMBNAIL_SIZE = '40px';
export const ATTACHMENT_REQUIRED_ERROR = 'Upload an attachment.';
export const REQUIRED_ASTERISK_WIDTH = '30';
export const REQUIRED_ASTERISK_HEIGHT = '9';
export const FILE_UPLOADER_ICON_SIZE = 20;
export const DEFAULT_QUESTIONNAIRE_ID = 123456789;
export const isImageType = (mimeType) => {
    return mimeType.split('/')[0] === 'image';
};
export const QUESTIONNAIRE_URL_PREFIX = 'v1/apd/questionnaire/question/companies';
export const OVERRIDE_FINAL_QUALITY_SCORE = 'Final Quality Score';
export const OVERRIDE_COMMENT = 'Comment';
export const QUESTIONNAIRE_OVERRIDE_SCORE_KEY = 'score';
//# sourceMappingURL=QuestionnaireConstants.js.map